<template>
  <div >
    <div class="connect_main" v-loading="connectMainLoading" :element-loading-text="connectMainLoadingText">
      <!-- <p class="fb">关联产品规格</p> -->
      <div class="search_product">
        <div class="goods_info" v-if="productData && !hideGoodsInfo">
          <div class="img_box"><img class="coverimg" :src="productData.img" /></div>
          <div class="con_box">
            <p class="name">{{productData.name}}</p>
            <p class="id">DD商品ID：{{productData.goods_id}}</p>
          </div>
        </div>
        <div class="add_line">
          <div style="display: flex;gap: 1em;white-space: nowrap;align-items: center;">
            <el-switch
                v-model="hide_selected_specs"
                active-text="隐藏已选规格"
                inactive-text="隐藏已选规格"
            ></el-switch>
            <el-button type="primary" size="small" v-if="productData && productData.dd_shop_app_status" @click="syncProduct()" :loading="is_syncing">同步抖店商品</el-button>
            <el-button class="search_btn" size="mini" plain @click="showProductMarks">查看标记货源</el-button>
            <el-button class="search_btn" size="mini" plain @click="onSearch">搜同款</el-button>
            <!-- <p class="add_btn" @click="showChangeLog()">搜同款</p> -->
          </div>
          <!-- <p class="clear" @click="clearSelConfig()"><i class="iconfont icon-delete"></i>清空匹配的规格</p> -->
        </div>
      </div>
      <!-- 多 1688 商品关联 Tab；时间：2026-08-17 -->
      <div class="offer_tabs_wrap">
        <div class="offer_tabs">
          <div
              v-for="(offer, oidx) in relative_offers"
              :key="offer.key"
              class="offer_tab"
              :class="{ active: active_offer_key === offer.key, disabled: is_geting }"
              @click="switchOfferTab(offer.key)"
          >
            <span class="offer_tab_label">{{ offerLabel(offer, oidx) }}</span>
            <span class="offer_tab_meta" v-if="offer.alibaba_goods_id">{{ offer.alibaba_goods_id }}</span>
            <span class="offer_tab_meta empty" v-else>未获取</span>
            <i
                v-if="relative_offers.length > 1"
                class="el-icon-close offer_tab_close"
                @click.stop="removeOfferTab(offer.key)"
            ></i>
          </div>
          <button type="button" class="offer_tab_add" :disabled="is_geting" :class="{ disabled: is_geting }" @click="appendOfferTab">
            <i class="el-icon-plus"></i>
            <span>追加关联</span>
          </button>
        </div>
        <div class="offer_url_row">
          <div class="url_bar offer_url_bar">
            <span class="url_label">直采链接</span>
            <el-input size="small" class="url_input" v-model="goods_url" clearable placeholder="粘贴 1688 商品详情链接，如 https://detail.1688.com/offer/xxx.html" @change="onGoodsUrlChange"></el-input>
            <el-button size="small" type="primary" plain :loading="is_geting" @click="getAlibabaSkuInfo()">获取规格</el-button>
          </div>
          <p class="offer_tabs_hint">每个 Tab 对应一个 1688 商品；切换后自动带入链接与规格。当前商品下可多选规格，多商品合起来即为组合。</p>
        </div>
      </div>
      <div class="config_wrap">
        <div class="config_table">
          <el-table :data="dd_sku_list" height="520" :row-class-name="tableRowClassName">
            <el-table-column label="抖店规格" prop="scope" width="240">
              <template slot-scope="scope">
                <div class="dd_sku_cell">
                  <img class="dd_sku_pic" v-if="scope.row.pic" @click="openImg(scope.row.pic, scope.row.dd_spec_value)" :src="scope.row.pic" alt="">
                  <div class="dd_sku_meta">
                    <p class="dd_sku_name" :title="scope.row.dd_spec_value">{{ scope.row.dd_spec_value || '-' }}</p>
                    <p class="dd_sku_price">￥{{ scope.row.price }}</p>
                    <div class="dd_sku_tags">
                      <span class="tag tag-order" v-if="scope.row.current_order_sku">当前订单</span>
                      <span class="tag tag-combo" v-if="(scope.row.relative_lines || []).length >= 2">组合 {{ scope.row.relative_lines.length }}</span>
                      <span class="tag tag-normal" v-else-if="(scope.row.relative_lines || []).length === 1">普通</span>
                      <span class="tag tag-empty" v-else>未关联</span>
                      <span class="tag tag-offer" v-if="countActiveOfferLines(scope.row)">本商品 {{ countActiveOfferLines(scope.row) }}</span>
                      <span class="tag tag-changed" v-if="scope.row.relative_sku_invalid_cleared || isRelativeLinesChanged(scope.row)">关联已变动</span>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="当前 1688 商品规格（可多选）" prop="scope" min-width="560">
              <template slot-scope="scope">
                <!-- 按当前 Tab 的 offer 编辑；支持多选；时间：2026-08-17 -->
                <div class="combo_edit_wrap">
                  <el-select
                      class="multi_sku_select"
                      size="small"
                      multiple
                      filterable
                      clearable
                      collapse-tags
                      :value="getActiveSelectedSkuIds(scope.row)"
                      placeholder="多选当前 1688 商品规格"
                      @visible-change="selectChange"
                      @change="onActiveMultiSelect(scope.row, $event)"
                  >
                    <el-option
                        v-for="(item,index) in current_sku" :key="String(item.source_skuId)+'-'+index"
                        :label="item.spec_value"
                        :value="String(item.source_skuId)"
                        v-show="!hide_selected_specs || !item.is_selected || getActiveSelectedSkuIds(scope.row).indexOf(String(item.source_skuId)) !== -1"
                    >
                      <div class="pdd_sku_info">
                        <img class="pdd_sku_pic" @click.stop="openImg(item.pic,item.spec_value)" :src="item.pic"/>
                        <span>{{item.spec_value}}</span>
                      </div>
                    </el-option>
                  </el-select>
                  <div
                      v-for="(line, lidx) in getActiveOfferLines(scope.row)"
                      :key="'edit-'+active_offer_key+'-'+line.source_skuId+'-'+lidx"
                      class="combo_edit_line"
                  >
                    <span class="line_idx">{{ lidx + 1 }}</span>
                    <div class="sel_sku_pic_box">
                      <img
                          v-if="getLinePic(line)"
                          class="sel_sku_pic"
                          :src="getLinePic(line)"
                          @click="openImg(getLinePic(line), getLineSpecText(line))"
                      />
                      <span v-else class="pic_placeholder">图</span>
                    </div>
                    <span class="line_spec_text" :title="getLineSpecText(line)">{{ getLineSpecText(line) }}</span>
                    <div class="qty_box">
                      <span class="qty_label">×</span>
                      <el-input-number
                          class="qty_input"
                          v-model="line.qty"
                          :min="1"
                          :max="999"
                          size="small"
                          controls-position="right"
                      />
                    </div>
                    <button type="button" class="icon_del_btn" title="移除此规格" @click="removeActiveOfferLine(scope.row, line)">
                      <i class="el-icon-close"></i>
                    </button>
                  </div>
                  <p class="combo_hint" v-if="!current_sku.length">请先在上方填写直采链接并「获取规格」</p>
                  <p class="combo_hint" v-else-if="!countActiveOfferLines(scope.row)">在上方下拉框多选本 1688 商品规格；切换 Tab 可配置其它 1688 商品</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="历史" prop="scope" width="88" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small" class="history_btn" @click="openRelativeHistory(scope.row)">记录</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="btn_wrap">
          <div class="action_bar">
            <el-button size="small" plain :loading="loading" @click="configSubmit(1)">临时关联</el-button>
            <el-button type="primary" size="small" :loading="loading" @click="configSubmit(0)">永久关联</el-button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
        :visible.sync="is_tongkuan"
        width="60%"
        top="6vh"
        append-to-body
        custom-class="tk-dialog"
        @click.self="is_tongkuan = false"
        class="custom-el-wrapper"
    >
      <div slot="title" class="tk-header">
        <span class="tk-header__bar"></span>
        <span class="tk-header__text">搜同款</span>
      </div>
      <div class="tongkuan_main tk-body">
        <!-- 左侧：过滤条件 + 图片预览 -->
        <aside class="tk-side">
          <section class="tk-panel tk-panel--preview">
            <img class="tk-preview__img" :src="imageUrl" v-if="imageUrl" alt="">
            <div class="tk-preview__empty" v-else>上传图片后预览</div>
          </section>
          <section class="tk-panel tk-panel--filters" v-loading="filterTypeLoading">
            <p class="tk-panel__title">过滤条件</p>
            <div class="tk-filter" v-for="(group, gIndex) in filterTypeList" :key="gIndex">
              <p class="tk-filter__name">{{ group.type_name }}</p>
              <el-checkbox-group class="tk-filter__opts" v-model="selectedFilterKeys">
                <el-checkbox
                    v-for="item in group.type_list"
                    :key="item.key"
                    :label="item.key"
                >{{ item.desc }}</el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="tk-filter__actions">
              <el-button size="small" @click="onFilterClearAll">全部清空</el-button>
              <el-button size="small" type="primary" @click="onFilterQuery">查询</el-button>
            </div>
          </section>
        </aside>

        <!-- 右侧：搜索条 + 结果统计 + 商品卡片 -->
        <section class="tk-main">
          <div class="tk-search">
            <i class="el-icon-search tk-search__ico"></i>
            <input class="tk-search__in" placeholder="点击输入框粘贴截图" @paste="handlePaste"/>
            <i class="iconfont icon-xiangji tk-search__cam"><input class="image-uploader" type="file" accept="image/*" capture="camera" @change="onFileChange"></i>
          </div>

          <div class="tk-resultbar" v-if="imageUrl" v-loading="searchLoading">
            <span class="tk-resultbar__title">相似款商品 <em>{{ similarData.length }}</em> 件</span>
          </div>

          <div class="tk-gridwrap" v-if="similarData.length>0">
            <div class="tk-grid">
              <div class="tk-card" v-for="(item,index) in similarData" :key="index">
                <div class="tk-card__img"><img :src="item.image" @click="openDetail(item.url)" /></div>
                <p class="tk-card__name" @click="openDetail(item.url)">{{item.subject}}</p>
                <p class="tk-card__no" :title="item.huohao">{{item.huohao}}</p>
                <p class="tk-card__price">￥{{item.consignPrice}}</p>
                <div class="tk-card__actions">
                  <button type="button" class="tk-card__btn tk-card__btn--plain" @click="openDetail(item.url)">查看</button>
                  <button type="button" class="tk-card__btn tk-card__btn--red" @click="selectProduct(item.url)">选择商品</button>
                </div>
              </div>
            </div>
          </div>
          <el-empty v-else description="暂无数据"></el-empty>
        </section>
      </div>
      <div slot="footer" class="tk-footer">
        <span class="tk-footer__hint">粘贴截图或点击相机上传商品图片，快速搜索 1688 相似款</span>
        <el-button size="small" @click="is_tongkuan = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog title="查看标记货源" :visible.sync="productMarkVisible" width="1100px" append-to-body class="custom-el-wrapper">
      <el-empty v-if="!productMarkLoading && !productMarkItems.length" description="无标记数据"></el-empty>
      <el-table v-else v-loading="productMarkLoading" :data="productMarkItems" max-height="480">
        <el-table-column label="图片" width="90" align="center">
          <template slot-scope="scope"><el-image v-if="scope.row.image" :src="scope.row.image" fit="cover" style="width:65px;height:65px" :preview-src-list="[scope.row.image]"></el-image><span v-else>-</span></template>
        </el-table-column>
        <el-table-column label="标题" prop="title" min-width="220" show-overflow-tooltip></el-table-column>
        <el-table-column label="商品ID" prop="offer_id" width="140"></el-table-column>
        <el-table-column label="价格" width="90"><template slot-scope="scope">{{ scope.row.price || '-' }}</template></el-table-column>
        <el-table-column label="商家名称" prop="shop_name" width="140" show-overflow-tooltip></el-table-column>
        <el-table-column label="标记时间" width="165"><template slot-scope="scope">{{ scope.row.mark_at_text || '-' }}</template></el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button size="mini" plain @click="openMarkedProduct(scope.row)">查看商品</el-button>
            <el-button size="mini" plain @click="selectMarkedProduct(scope.row)">选择商品</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
        :visible.sync="historyVisible"
        width="78%"
        title="历史关联1688商品规格记录"
        append-to-body
        @close="historyList = []"
        class="custom-el-wrapper"
    >
      <p class="history_spec_name" v-if="historySkuName">抖店规格：{{ historySkuName }}</p>
      <el-table :data="historyList" v-loading="historyLoading" max-height="480" empty-text="暂无历史关联记录">
        <el-table-column label="关联时间" prop="create_time_text" width="160"></el-table-column>
        <el-table-column label="关联类型" width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.is_permanent_relative == 1 ? '永久关联' : '临时关联' }}
          </template>
        </el-table-column>
        <el-table-column label="抖店商品ID" prop="dd_goods_id" width="200"></el-table-column>
        <!-- <el-table-column label="抖店规格" prop="dd_spec_name" width="300" align="left"></el-table-column> -->
        <el-table-column label="1688规格图" width="120" align="center">
          <template slot-scope="scope">
            <img
                v-if="scope.row.alibaba_sku_pic"
                class="history_pic"
                :src="scope.row.alibaba_sku_pic"
                @click="openImg(scope.row.alibaba_sku_pic, scope.row.alibaba_sku_name)"
            />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="1688规格" prop="alibaba_sku_name" width="400" align="left"></el-table-column>
        <el-table-column label="规格编码" prop="sku_code"  show-overflow-tooltip></el-table-column>
        <el-table-column label="1688规格图" width="120" align="center">
          <template slot-scope="scope">
            <el-button size="small" @click="copyLink(scope.row.alibaba_sku_url)">复制链接</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions,mapState,mapMutations } from "vuex";

export default {
  name: "goodsConnectBox",
  props: {
    /** 批量关联弹窗内复用时隐藏顶部抖店商品摘要，避免与左侧列表重复 */
    hideGoodsInfo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      shop_id: "",
      alibaba_sku_id:"",
      dd_goods_id: "",
      loading: true,
      productData:"",
      dd_sku_list:[],
      links_list:[{links:"",isUse:false,product_id:""}],
      isSubmit:false,
      is_tongkuan:false,
      current_sku:[],
      search_input:"",
      isSearch:false,
      similarData:"",
      searchLoading:false,
      order:"_score",
      product_loading:false,
      sku_id: '',
      order_product_id: '',
      dd_order_id: '',
      sku_exist: false,
      is_syncing: false,
      is_do_sync: false,
      is_geting: false,
      _offers_structure_changed: false,
      hide_selected_specs: false,
      goods_url:'',
      old_alibaba_goods_id: '',
      alibaba_goods_id:'',
      imageUrl: '',
      total: 0,
      filterTypeList: [],
      filterTypeLoading: false,
      selectedFilterKeys: [],
      appliedFilterKeys: [],
      historyVisible: false,
      historyLoading: false,
      historyList: [],
      historySkuName: '',
      /** 查看标记货源 */
      productMarkVisible: false,
      productMarkLoading: false,
      productMarkItems: [],
      /** 多 1688 商品 Tab；时间：2026-08-17 */
      relative_offers: [],
      active_offer_key: '',
      offer_tab_seq: 0,
    }
  },
  components:{
  },

  computed: {
    connectMainLoading() {
      return !!(this.loading || this.is_geting)
    },
    connectMainLoadingText() {
      return this.is_geting ? '正在获取1688规格...' : '加载中...'
    },
  },
  methods: {
    ...mapActions({
      GetAlibabaRelativeInfoData:"ucenter_order/GetAlibabaRelativeInfoData",
      // doSubmitRelative:"ucenter_order/doSubmitRelative",
      // opCheckoutSkuRelative:"ucenter_order/opCheckoutSkuRelative",
      doSyncDdProductInfo:"ucenter_order/doSyncDdProductInfo",
      doSubmitAlibabaSkuRelative:"ucenter_order/doSubmitAlibabaSkuRelative",
      GetAlibabaSkuInfoData:"ucenter_order/GetAlibabaSkuInfoData",
      doSearchAlibabaProductByImage:"ucenter_order/doSearchAlibabaProductByImage",
      getAlibabaProductFilterTypeList:"ucenter_order/getAlibabaProductFilterTypeList",
      GetAlibabaSkuRelativeHistory:"ucenter_order/GetAlibabaSkuRelativeHistory",
      getProductMarkable:"ucenter/getProductMarkable",
    }),
    setSkuIsChange(skuItem) {
      const relChanged = this.isRelativeLinesChanged(skuItem)
      skuItem.is_change = relChanged || (skuItem.goods_no != skuItem.sel_alibaba_product_sku_id && skuItem.sel_alibaba_product_sku_id != '') ? 1 : 0
    },
    /** 当前 Tab 的 1688 规格 id 集合 */
    getValidAlibabaSkuIdMap(pddSkuList) {
      const map = {}
      ;(pddSkuList || this.current_sku || []).forEach(s => {
        const sid = String(s.source_skuId || '')
        if (sid) map[sid] = true
      })
      return map
    },
    /**
     * 1688 规格加载后：不在列表内的关联 sku 从行中移除（下拉不显示），保留 _origin_relative_key 以标记变动
     */
    sanitizeRelativeLinesForOffer(row, pddSkuList, offerGid) {
      const gid = String(offerGid || '')
      const list = pddSkuList || []
      if (!gid || !list.length) return false
      const validIds = this.getValidAlibabaSkuIdMap(list)
      let cleared = false
      const kept = []
      ;(row.relative_lines || []).forEach(l => {
        const lg = String(l.alibaba_goods_id || '')
        const sid = String(l.source_skuId || '')
        const belongsToOffer = !lg || lg === gid
        if (belongsToOffer && sid && !validIds[sid]) {
          cleared = true
          return
        }
        kept.push(l)
      })
      if (!cleared) return false
      row.relative_lines = kept
      this.$set(row, 'relative_sku_invalid_cleared', true)
      const activeLines = this.getActiveOfferLines(row)
      row.sel_alibaba_product_sku_id = (activeLines[0] && activeLines[0].source_skuId) || ''
      return true
    },
    sanitizeAllRowsForActiveOffer(offerGid, pddSkuList) {
      const gid = String(offerGid || this.alibaba_goods_id || '')
      const list = pddSkuList || this.current_sku || []
      if (!gid || !list.length) return false
      let any = false
      ;(this.dd_sku_list || []).forEach(row => {
        if (this.sanitizeRelativeLinesForOffer(row, list, gid)) {
          any = true
          this.setSkuIsChange(row)
        }
      })
      return any
    },
    /** 当前订单规格行高亮；排版优化 2026-08-17 */
    tableRowClassName({ row }) {
      return row.current_order_sku ? 'is-current-order-row' : ''
    },
    /** 创建空关联 Tab */
    createEmptyOffer(alibaba_goods_id = '', goods_url = '', sku_list = []) {
      this.offer_tab_seq += 1
      const gid = String(alibaba_goods_id || '')
      return {
        key: 'offer_' + this.offer_tab_seq,
        alibaba_goods_id: gid,
        goods_url: goods_url || (gid ? ('https://detail.1688.com/offer/' + gid + '.html') : ''),
        sku_list: JSON.parse(JSON.stringify(sku_list || [])),
        title: '',
      }
    },
    offerLabel(offer, oidx) {
      if (offer && offer.title) return offer.title
      return '关联' + (oidx + 1)
    },
    getActiveOffer() {
      return this.relative_offers.find(o => o.key === this.active_offer_key) || null
    },
    /** 从全部 relative_lines 重建 Tab（保留已缓存 sku_list） */
    rebuildOffersFromLines(preferGoodsId, preferSkuList) {
      const prefer = String(preferGoodsId || this.alibaba_goods_id || '')
      // 兼容旧数据：无 offerId 的行归入当前主商品
      if (prefer) {
        ;(this.dd_sku_list || []).forEach(row => {
          ;(row.relative_lines || []).forEach(l => {
            if (!l.alibaba_goods_id) l.alibaba_goods_id = prefer
          })
        })
      }
      const idSet = []
      ;(this.dd_sku_list || []).forEach(row => {
        ;(row.relative_lines || []).forEach(l => {
          const gid = String(l.alibaba_goods_id || '')
          if (gid && idSet.indexOf(gid) === -1) idSet.push(gid)
        })
      })
      if (prefer && idSet.indexOf(prefer) === -1) idSet.unshift(prefer)
      const cache = {}
      ;(this.relative_offers || []).forEach(o => {
        if (o.alibaba_goods_id) cache[String(o.alibaba_goods_id)] = o
      })
      const offers = []
      if (idSet.length === 0) {
        offers.push(this.createEmptyOffer(prefer, this.goods_url, preferSkuList || this.current_sku))
      } else {
        idSet.forEach(gid => {
          const old = cache[gid]
          let skuList = []
          if (prefer && String(prefer) === gid && preferSkuList) {
            skuList = preferSkuList
          } else if (old && old.sku_list && old.sku_list.length) {
            skuList = old.sku_list
          } else if (prefer && String(prefer) === gid) {
            skuList = this.current_sku || []
          }
          offers.push(this.createEmptyOffer(
              gid,
              old && old.goods_url ? old.goods_url : ('https://detail.1688.com/offer/' + gid + '.html'),
              skuList
          ))
        })
      }
      this.relative_offers = offers
      const activeGid = prefer || (offers[0] && offers[0].alibaba_goods_id) || ''
      const found = offers.find(o => String(o.alibaba_goods_id) === String(activeGid)) || offers[0]
      const needFetch = !!(found && found.alibaba_goods_id && (!found.sku_list || !found.sku_list.length))
      this.applyOfferToView(found, needFetch)
    },
    applyOfferToView(offer, fetchIfNeed) {
      if (!offer) return
      this.active_offer_key = offer.key
      this.alibaba_goods_id = offer.alibaba_goods_id || ''
      this.goods_url = offer.goods_url || (offer.alibaba_goods_id ? ('https://detail.1688.com/offer/' + offer.alibaba_goods_id + '.html') : '')
      this.current_sku = this.setPddSkuSelected(JSON.parse(JSON.stringify(offer.sku_list || [])))
      const hasBaseline = (this.dd_sku_list || []).some(r => r._origin_relative_key)
      if (offer.sku_list && offer.sku_list.length && hasBaseline) {
        this.syncRelativeLinesSkuMeta(offer.sku_list, offer.alibaba_goods_id)
        this.sanitizeAllRowsForActiveOffer(offer.alibaba_goods_id, offer.sku_list)
        this.current_sku = this.setPddSkuSelected(this.current_sku)
      }
      if (fetchIfNeed && offer.alibaba_goods_id && (!offer.sku_list || !offer.sku_list.length)) {
        this.getAlibabaSkuInfo()
      }
    },
    switchOfferTab(key) {
      if (this.is_geting) return
      if (key === this.active_offer_key) return
      this.persistActiveOfferState()
      const offer = this.relative_offers.find(o => o.key === key)
      if (!offer) return
      this.applyOfferToView(offer, true)
    },
    persistActiveOfferState() {
      const offer = this.getActiveOffer()
      if (!offer) return
      offer.goods_url = this.goods_url || ''
      offer.alibaba_goods_id = this.alibaba_goods_id || this.extractProductIdSilent(this.goods_url) || offer.alibaba_goods_id || ''
      offer.sku_list = JSON.parse(JSON.stringify(this.current_sku || []))
    },
    appendOfferTab() {
      if (this.is_geting) return
      this.persistActiveOfferState()
      const offer = this.createEmptyOffer()
      this.relative_offers.push(offer)
      this.applyOfferToView(offer, false)
    },
    removeOfferTab(key) {
      if (this.is_geting) return
      if (this.relative_offers.length <= 1) {
        this.$message({ message: '至少保留一个关联', type: 'warning' })
        return
      }
      const offer = this.relative_offers.find(o => o.key === key)
      if (!offer) return
      const gid = String(offer.alibaba_goods_id || '')
      const doRemove = () => {
        // 规格 id：Tab 缓存 + 各行已归属该 offer 的关联（不依赖是否点过「获取规格」）
        const offerSkuIds = {}
        ;(offer.sku_list || []).forEach(s => {
          const sid = String(s.source_skuId || '')
          if (sid) offerSkuIds[sid] = true
        })
        if (gid) {
          ;(this.dd_sku_list || []).forEach(row => {
            ;(row.relative_lines || []).forEach(l => {
              if (String(l.alibaba_goods_id || '') === gid) {
                const sid = String(l.source_skuId || '')
                if (sid) offerSkuIds[sid] = true
              }
            })
          })
        }
        ;(this.dd_sku_list || []).forEach(row => {
          const beforeKey = this.serializeRelativeLines(row.relative_lines || [])
          row.relative_lines = (row.relative_lines || []).filter(l => {
            const lg = String(l.alibaba_goods_id || '')
            const sid = String(l.source_skuId || '')
            if (gid) {
              if (lg === gid) return false
              // 空 offerId 且规格属于该 Tab，一并清除
              if (!lg && sid && offerSkuIds[sid]) return false
              return true
            }
            // 删的是空 Tab：清掉空 offerId 行
            return !!lg
          })
          row.sel_alibaba_product_sku_id = row.relative_lines.length ? row.relative_lines[0].source_skuId : ''
          if (beforeKey !== this.serializeRelativeLines(row.relative_lines || [])) {
            this.$set(row, '_relative_dirty', true)
          }
        })
        // Tab 结构变化也算变更，避免行未清干净时误判「无变化」
        this._offers_structure_changed = true
        const idx = this.relative_offers.findIndex(o => o.key === key)
        this.relative_offers.splice(idx, 1)
        const next = this.relative_offers[Math.max(0, idx - 1)] || this.relative_offers[0]
        // 删 Tab 后勿用拉取规格重写基准；有缓存规格则直接切换
        const needFetch = !!(next && next.alibaba_goods_id && (!next.sku_list || !next.sku_list.length))
        this.applyOfferToView(next, needFetch)
        this.current_sku = this.setPddSkuSelected(this.current_sku)
      }
      if (gid) {
        this.$confirm('删除该关联将清除各抖店规格下属于该 1688 商品的已选规格，是否继续？', '提示', {
          type: 'warning',
        }).then(doRemove).catch(() => {})
      } else {
        doRemove()
      }
    },
    onGoodsUrlChange() {
      const offer = this.getActiveOffer()
      if (offer) offer.goods_url = this.goods_url || ''
    },
    extractProductIdSilent(url) {
      if (!url) return ''
      const match = String(url).match(/\/offer\/(\d+)\.html/)
      return match && match[1] ? match[1] : ''
    },
    getActiveOfferLines(row) {
      const gid = String(this.alibaba_goods_id || '')
      return (row.relative_lines || []).filter(l => {
        const lg = String(l.alibaba_goods_id || '')
        if (!gid) return !lg
        // 空 offerId 视为归属当前 Tab，否则会出现「删了 B 实际还在」
        return !lg || lg === gid
      })
    },
    countActiveOfferLines(row) {
      return this.getActiveOfferLines(row).filter(l => l.source_skuId).length
    },
    getActiveSelectedSkuIds(row) {
      const validIds = this.getValidAlibabaSkuIdMap(this.current_sku)
      return this.getActiveOfferLines(row)
          .map(l => String(l.source_skuId || ''))
          .filter(id => id && validIds[id])
    },
    onActiveMultiSelect(row, ids) {
      const gid = String(this.alibaba_goods_id || '')
      if (!gid || !this.current_sku || !this.current_sku.length) {
        this.$message({ message: '请先获取厂家直采规格信息', type: 'warning' })
        return
      }
      const selected = Array.isArray(ids) ? ids.map(String) : []
      // 其它 Tab 的行保留；当前 Tab（含空 offerId）整组按多选结果重建
      const other = (row.relative_lines || []).filter(l => {
        const lg = String(l.alibaba_goods_id || '')
        return lg && lg !== gid
      })
      const prevMap = {}
      this.getActiveOfferLines(row).forEach(l => {
        if (l.source_skuId) prevMap[String(l.source_skuId)] = l
      })
      const newLines = selected.map((id, idx) => {
        if (prevMap[id]) {
          const keep = Object.assign({}, prevMap[id])
          keep.sort = other.length + idx
          keep.alibaba_goods_id = gid
          return keep
        }
        const sku = this.getSelectedAlibabaSku(id)
        return {
          source_skuId: id,
          product_sku_id: Number((sku && sku.product_sku_id) || 0),
          qty: 1,
          sort: other.length + idx,
          alibaba_goods_id: gid,
          pic: (sku && sku.pic) || '',
          spec_value: (sku && sku.spec_value) || '',
        }
      })
      row.relative_lines = other.concat(newLines)
      row.sel_alibaba_product_sku_id = row.relative_lines.length ? row.relative_lines[0].source_skuId : ''
      this.$set(row, '_relative_dirty', true)
      this.current_sku = this.setPddSkuSelected(this.current_sku)
    },
    removeActiveOfferLine(row, line) {
      const ids = this.getActiveSelectedSkuIds(row).filter(id => String(id) !== String(line.source_skuId))
      this.onActiveMultiSelect(row, ids)
    },
    onSelPddProductSkuId(){
      let current_sku = this.current_sku
      this.current_sku = this.setPddSkuSelected(current_sku)
    },
    /**
     * 从接口 alibaba_relative_lines / goods_no 生成行快照（不写回 skuItem）
     */
    buildRelativeLinesSnapshot(skuItem, pddSkuList) {
      const lines = []
      const apiLines = skuItem.alibaba_relative_lines || []
      const mainRelSkuId = String(skuItem.goods_no || (skuItem.alibaba_sku && skuItem.alibaba_sku.source_skuId) || '')
      const resolveLinePic = (sourceSkuId, matched) => {
        if (matched && matched.pic) return matched.pic
        if (mainRelSkuId && mainRelSkuId === sourceSkuId && skuItem.alibaba_sku && skuItem.alibaba_sku.pic) {
          return skuItem.alibaba_sku.pic
        }
        return ''
      }
      const resolveLineSpec = (sourceSkuId, matched) => {
        if (matched && matched.spec_value) return matched.spec_value
        if (mainRelSkuId && mainRelSkuId === sourceSkuId && skuItem.alibaba_sku && skuItem.alibaba_sku.spec_value) {
          return skuItem.alibaba_sku.spec_value
        }
        return sourceSkuId
      }
      if (apiLines.length > 0) {
        apiLines.forEach((l, idx) => {
          const sourceSkuId = String(l.alibaba_sku_id || l.source_skuId || '')
          if (!sourceSkuId) return
          const matched = (pddSkuList || []).find(v => String(v.source_skuId) === sourceSkuId)
          lines.push({
            source_skuId: sourceSkuId,
            product_sku_id: Number(l.product_sku_id || (matched && matched.product_sku_id) || 0),
            qty: Math.max(1, Number(l.qty || 1)),
            sort: Number(l.sort != null ? l.sort : idx),
            alibaba_goods_id: String(l.alibaba_goods_id || this.alibaba_goods_id || ''),
            pic: (matched && matched.pic) || l.pic || resolveLinePic(sourceSkuId, matched),
            spec_value: (matched && matched.spec_value) || l.spec_value || resolveLineSpec(sourceSkuId, matched),
          })
        })
      } else if (skuItem.goods_no) {
        const sourceSkuId = String(skuItem.goods_no)
        const matched = (pddSkuList || []).find(v => String(v.source_skuId) === sourceSkuId)
        lines.push({
          source_skuId: sourceSkuId,
          product_sku_id: Number((matched && matched.product_sku_id) || skuItem.product_sku_id || 0),
          qty: 1,
          sort: 0,
          alibaba_goods_id: String(this.alibaba_goods_id || ''),
          pic: resolveLinePic(sourceSkuId, matched),
          spec_value: resolveLineSpec(sourceSkuId, matched),
        })
      }
      return lines
    },
    /**
     * 从接口 alibaba_relative_lines / goods_no 初始化可编辑组合行
     * 改动目的：FE-A 组合关联；时间：2026-08-17
     */
    buildRelativeLinesForSku(skuItem, pddSkuList, setOrigin = true) {
      const lines = this.buildRelativeLinesSnapshot(skuItem, pddSkuList)
      skuItem.relative_lines = lines
      skuItem.sel_alibaba_product_sku_id = lines.length ? lines[0].source_skuId : ''
      if (setOrigin || !skuItem._origin_relative_key) {
        skuItem._origin_relative_key = this.serializeRelativeLines(lines)
      }
      return skuItem
    },
    serializeRelativeLines(lines) {
      // 按 sku+qty+offer 排序，避免顺序差异误判；改动目的：删 B 能正确识别变更
      const parts = (lines || [])
          .filter(l => l && l.source_skuId)
          .map(l => ({
            s: String(l.source_skuId || ''),
            q: Number(l.qty || 1),
            g: String(l.alibaba_goods_id || ''),
          }))
      parts.sort((a, b) => (a.s + '|' + a.g).localeCompare(b.s + '|' + b.g))
      return JSON.stringify(parts)
    },
    isRelativeLinesChanged(row) {
      if (row && row._relative_dirty) return true
      const lines = (row.relative_lines || []).filter(l => l.source_skuId)
      const nowKey = this.serializeRelativeLines(lines.length ? lines : (row.sel_alibaba_product_sku_id ? [{
        source_skuId: row.sel_alibaba_product_sku_id,
        qty: 1,
        alibaba_goods_id: this.alibaba_goods_id || '',
      }] : []))
      return (row._origin_relative_key || '') !== nowKey
    },
    addComboLine(row) {
      if (!this.current_sku || this.current_sku.length === 0) {
        this.$message({ message: '请先获取厂家直采规格信息', type: 'warning' })
        return
      }
      if (!row.relative_lines) {
        this.$set(row, 'relative_lines', [])
      }
      row.relative_lines.push({
        source_skuId: '',
        product_sku_id: 0,
        qty: 1,
        sort: row.relative_lines.length,
        alibaba_goods_id: this.alibaba_goods_id || '',
        pic: '',
        spec_value: '',
      })
      this.current_sku = this.setPddSkuSelected(this.current_sku)
    },
    removeComboLine(row, lidx) {
      if (!row.relative_lines) return
      row.relative_lines.splice(lidx, 1)
      row.sel_alibaba_product_sku_id = row.relative_lines.length ? row.relative_lines[0].source_skuId : ''
      this.current_sku = this.setPddSkuSelected(this.current_sku)
    },
    onComboLineSkuChange(row, line) {
      const sku = this.getSelectedAlibabaSku(line.source_skuId)
      if (sku) {
        line.product_sku_id = sku.product_sku_id || 0
        line.pic = sku.pic || ''
        line.spec_value = sku.spec_value || ''
        line.alibaba_goods_id = this.alibaba_goods_id || line.alibaba_goods_id || ''
      } else {
        line.product_sku_id = 0
        line.pic = ''
        line.spec_value = ''
      }
      row.sel_alibaba_product_sku_id = (row.relative_lines[0] && row.relative_lines[0].source_skuId) || ''
      this.current_sku = this.setPddSkuSelected(this.current_sku)
    },
    getSelectedAlibabaSku(skuId) {
      if (!skuId) return null
      return this.current_sku.find(item => item.source_skuId == skuId) || null
    },
    /** 已关联行图片：优先当前 Tab 1688 规格列表，避免组合行误用同一 alibaba_sku 图 */
    getLinePic(line) {
      const sku = this.getSelectedAlibabaSku(line && line.source_skuId)
      return (sku && sku.pic) || (line && line.pic) || ''
    },
    getLineSpecText(line) {
      const sku = this.getSelectedAlibabaSku(line && line.source_skuId)
      return (sku && sku.spec_value) || (line && line.spec_value) || (line && line.source_skuId) || '-'
    },
    /** 用当前 offer 的 1688 规格列表刷新 relative_lines 的 pic/spec_value */
    syncRelativeLinesSkuMeta(pddSkuList, offerGid) {
      const gid = String(offerGid || this.alibaba_goods_id || '')
      const list = pddSkuList || this.current_sku || []
      if (!list.length) return
      const map = {}
      list.forEach(s => {
        const sid = String(s.source_skuId || '')
        if (sid) map[sid] = s
      })
      ;(this.dd_sku_list || []).forEach(row => {
        ;(row.relative_lines || []).forEach(l => {
          const lg = String(l.alibaba_goods_id || '')
          if (gid && lg && lg !== gid) return
          const sid = String(l.source_skuId || '')
          const sku = map[sid]
          if (!sku) return
          l.pic = sku.pic || ''
          l.spec_value = sku.spec_value || l.spec_value || sid
          l.product_sku_id = Number(sku.product_sku_id || l.product_sku_id || 0)
        })
      })
    },
    openSelectedSkuImg(row) {
      const sku = this.getSelectedAlibabaSku(row.sel_alibaba_product_sku_id)
      if (sku && sku.pic) {
        this.openImg(sku.pic, sku.spec_value)
      }
    },
    setPddSkuSelected(pddSkuList){
      let sel_ids = []
      let dd_sku_list = this.dd_sku_list
      for(var i in dd_sku_list){
        const lines = dd_sku_list[i].relative_lines || []
        if (lines.length) {
          lines.forEach(l => {
            if (l.source_skuId) sel_ids.push(l.source_skuId)
          })
        } else if(dd_sku_list[i].sel_alibaba_product_sku_id){
          sel_ids.push(dd_sku_list[i].sel_alibaba_product_sku_id)
        }
      }
      for(var i in pddSkuList){
        if(sel_ids.findIndex(val => val == pddSkuList[i].source_skuId) !== -1){
          pddSkuList[i].is_selected = true
        }else{
          pddSkuList[i].is_selected = false
        }
      }
      return pddSkuList
    },
    copyLink(url) {
      this.$copyText(url).then(() => {
        this.$message({ message: '链接已复制', type: 'success' })
      }, (err) => {
        this.$message({ message: '复制失败', type: 'error' })
      })
    },
    openRelativeHistory(row) {
      this.historySkuName = row.dd_spec_value || ''
      this.historyVisible = true
      this.historyLoading = true
      this.historyList = []
      this.GetAlibabaSkuRelativeHistory({
        data: { dd_sku_id: row.sku_id },
        success: (res) => {
          this.historyLoading = false
          if (res.code === 200) {
            this.historyList = res.data || []
          } else {
            this.$message({ message: res.msg, type: 'error' })
          }
        },
      })
    },
    openImg(pic,name) {
      let htm = ''
      if(!pic){
        htm = '<p>图片未更新</p>'
      }else{
        htm = '<img width="100%" style="object-fit: cover;margin-right: 10px;" src="' + pic + '" alt="">'
      }

      this.$alert(htm, name, {
        dangerouslyUseHTMLString: true,
        showClose: false,
        confirmButtonText: '关闭',
        closeOnClickModal: true,
        closeOnPressEscape: true,
        customClass: 'zdy-message-box'
      });
    },
    syncProduct(){
      this.doSyncDdProductInfo({data:{dd_goods_id:this.dd_goods_id,shop_id:this.shop_id, order_product_id:this.order_product_id},success:(res)=>{
          this.is_do_sync = true
          if(res.code == 200){
            this.getProductInfo()
          }else{
            this.$message({message: res.msg,type: 'error',})
          }
        }})
    },
    clean(){
      this.shop_id = ''
      this.alibaba_sku_id = ''
      this.dd_goods_id = ''
      this.loading = true
      this.productData = null
      this.dd_sku_list = []
      this.links_list = [{ links: '', isUse: false, product_id: '' }]
      this.isSubmit = false
      this.is_tongkuan = false
      this.current_sku = []
      this.search_input = ''
      this.isSearch = false
      this.similarData = []
      this.searchLoading = false
      this.product_loading = false
      this.sku_id = ''
      this.order_product_id = ''
      this.dd_order_id = ''
      this.sku_exist = false
      this.is_syncing = false
      this.is_do_sync = false
      this.is_geting = false
      this._offers_structure_changed = false
      this.hide_selected_specs = false
      this.goods_url = ''
      this.old_alibaba_goods_id = ''
      this.alibaba_goods_id = ''
      this.imageUrl = ''
      this.total = 0
      this.selectedFilterKeys = []
      this.appliedFilterKeys = []
      this.historyVisible = false
      this.historyLoading = false
      this.historyList = []
      this.historySkuName = ''
      // 货源标记相关
      this.productMarkVisible = false
      this.productMarkLoading = false
      this.productMarkItems = []
      //多 1688 商品 Tab相关
      this.relative_offers = []
      this.active_offer_key = ''
      this.offer_tab_seq = 0
    },
    init(alibaba_sku_id,dd_goods_id,shop_id,dd_sku_id=0,order_product_id=0,dd_order_id=''){//获取商品信息
      this.alibaba_sku_id = alibaba_sku_id;
      this.shop_id = shop_id
      this.dd_goods_id = dd_goods_id
      this.sku_id = dd_sku_id
      this.order_product_id = order_product_id
      this.dd_order_id = dd_order_id
      this.goods_url = ''
      this.old_alibaba_goods_id = ''
      this.alibaba_goods_id = ''
      this.imageUrl = ''
      this.similarData = []
      this.relative_offers = []
      this.active_offer_key = ''
      this.offer_tab_seq = 0
      this._offers_structure_changed = false
      this.getProductInfo()
    },

    //获取1688规格信息
    getAlibabaSkuInfo(){
      let that = this
      this.alibaba_goods_id = this.extractProductId();
      if(!this.alibaba_goods_id) return;
      that.is_geting = true

      let params = {alibaba_goods_id:this.alibaba_goods_id,dd_goods_id:this.dd_goods_id,dd_sku_id:this.sku_id,order_product_id:this.order_product_id}
      this.GetAlibabaSkuInfoData({data:params,success:(res)=>{
          this.is_geting = false;
          if(res.code===200){
            const prevSkuList = JSON.parse(JSON.stringify(this.dd_sku_list || []))
            this.current_sku = []
            this.dd_sku_list = []
            this.productData = JSON.parse(JSON.stringify(res.data))
            let skuList = JSON.parse(JSON.stringify(res.data.dd_sku))
            let pddSkuList = JSON.parse(JSON.stringify(res.data.pdd_sku))

            for(let i in skuList){
              skuList[i].sku = []
              skuList[i].sel_alibaba_product_sku_id = ""
              skuList[i].current_order_sku = false
              skuList[i].is_change = 0

              var cindex = pddSkuList.findIndex(val => val.source_skuId == skuList[i].goods_no)
              if(cindex !== -1){
                skuList[i].sel_alibaba_product_sku_id = skuList[i].goods_no
              }

              // var nindex = pddSkuList.findIndex(val => val.spec_value == skuList[i].dd_spec_value)
              var nindex = pddSkuList.findIndex(val => val.sku_value == skuList[i].sku_value)
              if(cindex === -1 && nindex !== -1 && skuList[i].sku_value){
                skuList[i].sel_alibaba_product_sku_id = pddSkuList[nindex].source_skuId
              }
              // 拉取新 offer：保留编辑态（含删 B 后为空），禁止用 goods_no 把基准/行重写回去
              const oldSku = prevSkuList.find(v => String(v.sku_id) === String(skuList[i].sku_id))
              if (oldSku && (oldSku._origin_relative_key || Array.isArray(oldSku.relative_lines))) {
                skuList[i].relative_lines = JSON.parse(JSON.stringify(oldSku.relative_lines || []))
                if (oldSku.alibaba_relative_lines) {
                  skuList[i].alibaba_relative_lines = JSON.parse(JSON.stringify(oldSku.alibaba_relative_lines))
                }
                skuList[i]._origin_relative_key = oldSku._origin_relative_key || ''
                if (oldSku._relative_dirty) {
                  skuList[i]._relative_dirty = true
                }
                if (!skuList[i]._origin_relative_key) {
                  // 基准只能来自接口关联，不能用已删过 B 的编辑态
                  const baseline = this.buildRelativeLinesSnapshot(Object.assign({}, skuList[i], {
                    relative_lines: undefined,
                    alibaba_relative_lines: oldSku.alibaba_relative_lines || skuList[i].alibaba_relative_lines,
                  }), pddSkuList)
                  skuList[i]._origin_relative_key = this.serializeRelativeLines(baseline)
                }
                skuList[i].sel_alibaba_product_sku_id = (skuList[i].relative_lines[0] && skuList[i].relative_lines[0].source_skuId) || ''
              } else {
                this.buildRelativeLinesForSku(skuList[i], pddSkuList)
              }
              this.setSkuIsChange(skuList[i])
            }

            if(this.sku_id){
              let sidx = skuList.findIndex(v => v.sku_id==this.sku_id)
              if(sidx === -1){
                this.sku_exist = false
                if(this.is_do_sync){
                  this.$alert('该商品规格不存在，请检查抖店商品是否已删除或更新商品规格');
                  return;
                }
                this.syncProduct()
                return;
              }else{
                this.sku_exist = true
                let first_sku = skuList.splice(sidx, 1)[0]
                first_sku.current_order_sku = true
                skuList.unshift(first_sku)
              }
            }

            this.dd_sku_list = skuList
            this.syncRelativeLinesSkuMeta(pddSkuList, this.alibaba_goods_id)
            this.sanitizeAllRowsForActiveOffer(this.alibaba_goods_id, pddSkuList)
            this.current_sku = this.setPddSkuSelected(pddSkuList)
            this.syncFetchedOfferToTabs(pddSkuList)

          }else{

            this.$message({message: res.msg,type: 'error',});
          }
        }})
    },
    syncFetchedOfferToTabs(pddSkuList) {
      const gid = String(this.alibaba_goods_id || '')
      const url = this.goods_url || (gid ? ('https://detail.1688.com/offer/' + gid + '.html') : '')
      const skuList = JSON.parse(JSON.stringify(pddSkuList || []))
      if (!this.relative_offers.length) {
        const offer = this.createEmptyOffer(gid, url, skuList)
        this.relative_offers = [offer]
        this.active_offer_key = offer.key
        return
      }
      const dup = this.relative_offers.find(o => o.key !== this.active_offer_key && String(o.alibaba_goods_id) === gid && gid)
      if (dup) {
        dup.goods_url = url
        dup.sku_list = skuList
        const cur = this.getActiveOffer()
        if (cur && cur.key !== dup.key && (!cur.alibaba_goods_id || String(cur.alibaba_goods_id) === gid)) {
          const idx = this.relative_offers.findIndex(o => o.key === cur.key)
          if (idx !== -1 && this.relative_offers.length > 1) this.relative_offers.splice(idx, 1)
        }
        this.applyOfferToView(dup, false)
        this.$message({ message: '该 1688 商品已在「' + this.offerLabel(dup, this.relative_offers.indexOf(dup)) + '」中，已切换过去', type: 'info' })
        return
      }
      const offer = this.getActiveOffer()
      if (offer) {
        offer.alibaba_goods_id = gid
        offer.goods_url = url
        offer.sku_list = skuList
      } else {
        this.rebuildOffersFromLines(gid, skuList)
      }
    },
    refresh(){
      // this.page_data.page = 1
      this.getProduct()
    },
    getProductInfo(){
      let that = this
      that.loading = true
      let params = {alibaba_sku_id:this.alibaba_sku_id,dd_goods_id:this.dd_goods_id,dd_sku_id:this.sku_id,dd_order_id:this.dd_order_id,order_product_id:this.order_product_id}
      this.GetAlibabaRelativeInfoData({data:params,success:(res)=>{
          that.loading = false
          if(res.code===200){
            // console.log('relative info',res,this.is_do_sync)

            if(res.data == 100){
              if(this.is_do_sync){
                this.$message({message: "该商品不存在，请检查抖店商品",type: 'error',});
                return;
              }
              this.syncProduct()
              return;
            }

            this.productData = JSON.parse(JSON.stringify(res.data))
            if(res.data.alibaba_goods_id){
              this.old_alibaba_goods_id = res.data.alibaba_goods_id
              this.alibaba_goods_id = res.data.alibaba_goods_id
              this.goods_url = 'https://detail.1688.com/offer/'+this.alibaba_goods_id+'.html'
            }
            // console.log(5555,this.alibaba_goods_id)
            let skuList = JSON.parse(JSON.stringify(res.data.dd_sku))
            let pddSkuList = JSON.parse(JSON.stringify(res.data.pdd_sku))

            for(let i in skuList){
              skuList[i].sku = []
              skuList[i].sel_alibaba_product_sku_id = ""
              skuList[i].current_order_sku = false

              var cindex = pddSkuList.findIndex(val => val.source_skuId == skuList[i].goods_no)
              if(cindex !== -1){
                skuList[i].sel_alibaba_product_sku_id = skuList[i].goods_no
              }

              // var nindex = pddSkuList.findIndex(val => val.spec_value == skuList[i].dd_spec_value)
              var nindex = pddSkuList.findIndex(val => val.sku_value == skuList[i].sku_value)
              if(cindex === -1 && nindex !== -1 && skuList[i].sku_value){
                skuList[i].sel_alibaba_product_sku_id = pddSkuList[nindex].source_skuId
              }
              // 初始化组合关联行；改动目的：FE-A；时间：2026-08-17
              this.buildRelativeLinesForSku(skuList[i], pddSkuList)
            }

            if(this.sku_id){
              let sidx = skuList.findIndex(v => v.sku_id==this.sku_id)
              if(sidx === -1){
                this.sku_exist = false
                if(this.is_do_sync){
                  this.$alert('该商品规格不存在，请检查抖店商品是否已删除或更新商品规格');
                  return;
                }
                this.syncProduct()
                return;
              }else{
                this.sku_exist = true
                let first_sku = skuList.splice(sidx, 1)[0]
                first_sku.current_order_sku = true
                skuList.unshift(first_sku)
                // this.getBase64Image(this.productData.img).then(res=>{
                // 	this.imageUrl = res;
                // })
                this.imageUrl = this.productData.img;
              }
            }

            this.dd_sku_list = skuList
            this.current_sku = this.setPddSkuSelected(pddSkuList)
            this.rebuildOffersFromLines(this.alibaba_goods_id, pddSkuList)
            // 填完空 offerId 后再固化变更基准，避免「删 B」与初始快照对不上；基准含可能已失效 sku
            ;(this.dd_sku_list || []).forEach(row => {
              row._origin_relative_key = this.serializeRelativeLines(row.relative_lines || [])
            })
            ;(this.dd_sku_list || []).forEach(row => { this.$set(row, '_relative_dirty', false) })
            this._offers_structure_changed = false
            if (pddSkuList && pddSkuList.length && this.alibaba_goods_id) {
              this.syncRelativeLinesSkuMeta(pddSkuList, this.alibaba_goods_id)
              this.sanitizeAllRowsForActiveOffer(this.alibaba_goods_id, pddSkuList)
              this.current_sku = this.setPddSkuSelected(this.current_sku)
            }
            this.$nextTick(function(){
              that.loading = false;
            })
          } else {
            //需多判断code=500的状态
            if(res.code == 201||res.code == 500){
              if(this.is_do_sync){
                this.$message({message: "该商品不存在，请检查抖店商品",type: 'error',});
                return;
              }
              this.syncProduct()
              return;
            }
            this.$message({message: res.msg,type: 'error',});
          }
        }})
    },
    onFileChange(e){
      const file = e.target.files[0];
      if (!file) return;

      // 创建一个FileReader实例
      const reader = new FileReader();

      // 读取文件为DataURL（Base64编码）
      reader.readAsDataURL(file);

      // 处理文件读取完成后的事件
      reader.onload = (e) => {
        this.imageUrl = e.target.result; // e.target.result 就是图片的Base64编码
        this.refresh()
      };

      // 错误处理
      reader.onerror = error => console.log('Error: ', error);
    },
    selectProduct(url){//选中同款商品
      // let list = this.links_list
      // if(!list[list.length - 1].isUse){
      // 	list[list.length - 1].links = url
      // }else{
      // 	this.links_list.push({links:url,isUse:false,product_id:""})
      // }
      // this.$message({message: '链接复制成功！',type: 'success',});
      this.goods_url = url
      const offer = this.getActiveOffer()
      const oldGid = String((offer && offer.alibaba_goods_id) || this.alibaba_goods_id || '')
          // 搜同款换商品后，清空当前 Tab 已选规格与 sku 选项（不影响其他 Tab）
      ;(this.dd_sku_list || []).forEach(row => {
        if (oldGid) {
          row.relative_lines = (row.relative_lines || []).filter(l => String(l.alibaba_goods_id || '') !== oldGid)
        } else {
          row.relative_lines = (row.relative_lines || []).filter(l => String(l.alibaba_goods_id || ''))
        }
        row.sel_alibaba_product_sku_id = row.relative_lines.length ? row.relative_lines[0].source_skuId : ''
      })
      this.current_sku = []
      const newGid = this.extractProductIdSilent(url) || ''
      this.alibaba_goods_id = newGid
      if (offer) {
        offer.goods_url = url
        offer.sku_list = []
        offer.alibaba_goods_id = newGid
      }
      setTimeout(()=>{this.is_tongkuan = false},500)
    },
    showProductMarks(){
      if (!this.shop_id || !this.dd_goods_id) {
        this.$message.warning('当前关联商品信息未加载完成')
        return
      }
      this.productMarkVisible = true
      this.productMarkLoading = true
      this.productMarkItems = []
      this.getProductMarkable({data:{shop_id:this.shop_id,dd_goods_id:this.dd_goods_id},success:(res)=>{
        this.productMarkLoading = false
        if (res.code === 200) {
          this.productMarkItems = Array.isArray(res.data) ? res.data : []
        } else {
          this.$message.error(res.message || '获取标记货源失败')
        }
      }})
    },
    getMarkedProductLink(item){
      return item && item.offer_id ? `https://detail.1688.com/offer/${item.offer_id}.html` : ''
    },
    openMarkedProduct(item){
      const url = this.getMarkedProductLink(item)
      if (url) window.open(url, '_blank', 'noopener,noreferrer')
    },
    selectMarkedProduct(item){
      const url = this.getMarkedProductLink(item)
      if (!url) return
      this.selectProduct(url)
      this.productMarkVisible = false
    },
    onSearch(){
      this.is_tongkuan = true
      this.loadFilterTypeList()
      setTimeout(()=>{
        this.getProduct()
      },100)
    },
    loadFilterTypeList(){
      if(this.filterTypeList.length > 0) return
      this.filterTypeLoading = true
      this.getAlibabaProductFilterTypeList({
        data: {},
        success: (res) => {
          this.filterTypeLoading = false
          if(res.code === 200){
            this.filterTypeList = res.data || []
          }else{
            this.$message({message: res.msg, type: 'error'})
          }
        },
      })
    },
    onFilterQuery(){
      this.appliedFilterKeys = [...this.selectedFilterKeys]
      if(this.imageUrl){
        this.getProduct()
      }
    },
    onFilterClearAll(){
      this.selectedFilterKeys = []
      this.appliedFilterKeys = []
      if(this.imageUrl){
        this.getProduct()
      }
    },
    getProduct(){
      if(this.product_loading) return
      if(!this.imageUrl) return
      this.product_loading = true
      this.searchLoading = true
      this.list = []
      document.documentElement.scrollTop = 400
      let searchParams = this.searchParams
      let param = {
        limit:this.similarData.limit,
        page:this.similarData.current_page,
        image:this.imageUrl,
        order:this.order,
        filter: this.appliedFilterKeys.join(','),
      }
      Object.assign(param, searchParams)
      // console.log(param)
      this.doSearchAlibabaProductByImage({data:param,success:(res)=>{
          if(res.code===200){
            this.similarData = res.data
          } else {
            this.$message({message: res.msg,type: 'error',});
          }
          this.product_loading = false
          this.searchLoading = false
        }})
    },
    getBase64Image(imgUrl) {
      return new Promise((resolve, reject) => {
        const image = new Image();
        image.setAttribute('crossOrigin', 'anonymous');
        image.addEventListener('load', () => {
          try {
            const canvas = document.createElement('canvas');
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext('2d');
            context.drawImage(image, 0, 0);
            const base64Image = canvas.toDataURL('image/png');
            resolve(base64Image);
          } catch (error) {
            reject(error);
          }
        });
        image.addEventListener('error', error => reject(error));
        image.src = imgUrl;
      });
    },
    handlePaste(event) {
      const items = (event.clipboardData || window.clipboardData).items;
      for (let i = 0; i < items.length; i++) {
        if (items[i].kind === 'file') {
          const file = items[i].getAsFile();
          if (file.type.startsWith('image/')) {
            // 创建一个FileReader对象
            const reader = new FileReader();
            reader.onload = (e) => {
              // 读取完成后，将图片的Data URL赋值给pastedImageUrl
              this.imageUrl = e.target.result;
              this.refresh()
            };
            // 以Data URL的形式读取文件
            reader.readAsDataURL(file);
            // 停止循环，因为我们只处理第一个图片文件
            break;
          }
        }
      }
    },
    openDetail(routePath){
      // const fullPath = this.$router.resolve(routePath).href;
      window.open(routePath, '_blank');
    },


    configSubmit(is_temporary_relative = 0){//关联商品规格（组合多行 items 提交；FE-A；2026-08-17）

      let that = this
      let skuList = this.dd_sku_list
      // 临时关联可不强求已打开链接（已有 relative_lines 即可）；永久关联同理
      this.loading = true;
      const items = []
      let anyChanged = !!this._offers_structure_changed
      for (let i in skuList) {
        const row = skuList[i]
        let lines = (row.relative_lines || []).filter(l => l.source_skuId)
        if (is_temporary_relative == 1) {
          // 临时：只提交当前订单规格
          if (String(row.sku_id) !== String(this.sku_id)) continue
        }
        const changed = this.isRelativeLinesChanged(row)
        if (lines.length === 0) {
          // 兼容：单选旧字段
          if (row.sel_alibaba_product_sku_id) {
            lines = [{
              source_skuId: row.sel_alibaba_product_sku_id,
              product_sku_id: row.product_sku_id || 0,
              qty: 1,
              alibaba_goods_id: this.alibaba_goods_id || '',
            }]
          } else {
            // 原来有关联、现在清空：也算变更（永久关联需带空行由后端覆盖时另议，这里至少不误判无变化）
            if (changed || (row._origin_relative_key && row._origin_relative_key !== '[]')) {
              anyChanged = true
            }
            continue
          }
        }
        if (changed) anyChanged = true
        // 永久：有 lines 都提交（删 B 只留 A 也必须能进 items）；临时：当前规格
        items.push({
          dd_sku_id: row.sku_id,
          sku_id: row.sku_id,
          lines: lines.map((l, idx) => ({
            alibaba_goods_id: String(l.alibaba_goods_id || this.alibaba_goods_id || ''),
            source_skuId: String(l.source_skuId),
            product_sku_id: Number(l.product_sku_id || 0),
            qty: Math.max(1, Number(l.qty || 1)),
            sort: idx,
          })),
          _changed: changed,
        })
      }

      if (items.length == 0) {
        this.loading = false;
        this.$message({ message: '请先选择要关联的1688规格', type: 'warning' });
        return;
      }
      if (!anyChanged) {
        this.loading = false;
        this.$message({
          message:'关联数据无变化，已关联成功',
          type:'success',
          duration:1000,
          onClose: () => that.$emit('close')
        });
        return;
      }
      // 去掉前端标记再提交
      items.forEach(it => { delete it._changed })

      // 校验每行有 offerId（临时可用已有行上的 alibaba_goods_id）
      for (const it of items) {
        for (const line of it.lines) {
          if (!line.alibaba_goods_id && !this.alibaba_goods_id) {
            this.loading = false;
            this.$message({ message: '请先获取厂家直采商品sku信息（填写1688链接）', type: 'warning' });
            return;
          }
          if (!line.alibaba_goods_id) {
            line.alibaba_goods_id = String(this.alibaba_goods_id)
          }
        }
      }

      this.doSubmitAlibabaSkuRelative({
        data: {
          items: items,
          dd_goods_id: this.dd_goods_id,
          order_product_id: this.order_product_id,
          is_temporary_relative: is_temporary_relative,
          // 兼容后端旧校验：附带主 offer（首行）
          alibaba_goods_id: items[0].lines[0].alibaba_goods_id || this.alibaba_goods_id,
        },
        success: (res) => {
          this.loading = false;
          if(res.code == 200){
            this.getProductInfo()
            this.$message({message: res.msg,type: 'success',duration:1000,onClose:(res)=>{
                that.$emit('close')
              }})
          }else{
            this.$message({message: res.msg,type: 'error',})
          }
        }})

    },
    clearSelConfig(){//清除选中的关联规格
      let skuList = this.dd_sku_list
      for(let i in skuList){
        skuList[i].sel_alibaba_product_sku_id = ""
        skuList[i].relative_lines = []
        skuList[i]._origin_relative_key = this.serializeRelativeLines([])
      }
      this.dd_sku_list = skuList
      this.current_sku = this.setPddSkuSelected(this.current_sku)
    },

    selectChange(value){//检测无规格
      if(value && this.current_sku.length==0){
        this.$message({message: '暂无数据，请先获取厂家直采规格信息！',type: 'warning',});
      }
    },
    extractProductId() {
      if(!this.goods_url){
        this.$message({message:'请输入厂家直采商品链接',type: 'warning'})
        return false;
      }
      const regex = /\/offer\/(\d+)\.html/;
      const match = this.goods_url.match(regex);
      if (match && match[1]) {
        return match[1];
      } else {
        this.$message({message:'未获读取到商品id，请输入厂家直采商品详情的链接',type: 'warning'})
        return false;
      }
    }



  }
}
</script>

<style scoped>

.ct_name{display: flex;align-items: center;text-align: justify;}
.ct_name .pic{width: 40px;height: 40px;margin-right: 5px;cursor: pointer;border-radius: 4px;object-fit: cover;}
.history_spec_name{margin: 0 0 12px;font-size: 14px;color: #333;}
.history_pic{width: 40px;height: 40px;object-fit: cover;cursor: pointer;border-radius: 4px;margin: 0 auto;}
.pdd_sku_info{display: flex;align-items: center;}
.pdd_sku_info .pdd_sku_pic{width: 30px;height: 30px;margin-right: 10px;border-radius: 3px;object-fit: cover;}
.sel_sku_wrap{display: flex;align-items: center;gap: 8px;width: 100%;}
.sel_sku_pic_box{flex-shrink: 0;width: 36px;height: 36px;background: #f7f7f7;border: 1px solid #eee;border-radius: 4px;overflow: hidden;display: flex;align-items: center;justify-content: center;}
.sel_sku_pic{width: 100%;height: 100%;object-fit: cover;cursor: pointer;display: block;}
.pic_placeholder{font-size: 12px;color: #ccc;}
.sel_sku_select{flex: 1;min-width: 0;}

/* 多 1688 关联 Tab */
.offer_tabs_wrap{margin: 0 0 12px;padding: 0 0 4px;}
.offer_tabs{display: flex;flex-wrap: wrap;align-items: stretch;gap: 8px;}
.offer_tab{
  position: relative;display: flex;flex-direction: column;justify-content: center;
  min-width: 110px;max-width: 180px;padding: 8px 28px 8px 12px;
  border: 1px solid #eee;border-radius: 6px;background: #fafafa;cursor: pointer;
}
.offer_tab:hover{border-color: #ffccc7;background: #fffafa;}
.offer_tab.active{border-color: var(--red, #f0423f);background: #fff1f0;box-shadow: inset 0 -2px 0 var(--red, #f0423f);}
.offer_tab_label{font-size: 13px;font-weight: 600;color: #333;line-height: 1.2;}
.offer_tab.active .offer_tab_label{color: var(--red, #f0423f);}
.offer_tab_meta{margin-top: 4px;font-size: 11px;color: #999;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
.offer_tab_meta.empty{color: #ccc;}
.offer_tab_close{
  position: absolute;top: 6px;right: 6px;font-size: 12px;color: #bbb;padding: 2px;border-radius: 2px;
}
.offer_tab_close:hover{color: #f0423f;background: #fff;}
.offer_tab_add{
  display: inline-flex;align-items: center;gap: 4px;height: auto;min-height: 44px;
  padding: 0 14px;border: 1px dashed #ffccc7;border-radius: 6px;background: #fff;
  color: var(--red, #f0423f);font-size: 13px;cursor: pointer;
}
.offer_tab.disabled,
.offer_tab.disabled:hover{cursor: not-allowed;opacity: 0.65;pointer-events: none;}
.offer_tab_add.disabled,
.offer_tab_add:disabled{cursor: not-allowed;opacity: 0.55;pointer-events: none;}
.offer_tab_add.disabled:hover,
.offer_tab_add:disabled:hover{background: #fff;border-style: dashed;}
.offer_tabs_hint{margin: 0;font-size: 12px;color: #999;line-height: 1.4;flex: 1;min-width: 180px;}
.offer_url_row{display: flex;align-items: center;gap: 12px;margin-top: 10px;width: 100%;}
.offer_url_bar{margin-top: 0;flex: 1.4;min-width: 320px;width: auto;}
.offer_url_bar .url_input{max-width: none;}
.multi_sku_select{width: 100%;margin-bottom: 4px;}
.line_spec_text{flex: 1;min-width: 0;font-size: 12px;color: #333;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
.tag-offer{background: #e6f7ff;border-color: #91d5ff;color: #096dd9;}

/* 抖店规格列 */
.dd_sku_cell{display: flex;align-items: flex-start;gap: 10px;padding: 4px 0;}
.dd_sku_pic{width: 48px;height: 48px;border-radius: 6px;object-fit: cover;cursor: pointer;flex-shrink: 0;background: #f5f5f5;}
.dd_sku_meta{flex: 1;min-width: 0;}
.dd_sku_name{margin: 0;font-size: 13px;line-height: 1.4;color: #333;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;}
.dd_sku_price{margin: 4px 0 6px;font-size: 13px;color: var(--red, #f0423f);font-weight: 600;}
.dd_sku_tags{display: flex;flex-wrap: wrap;gap: 4px;}
.tag{display: inline-block;padding: 1px 6px;font-size: 11px;line-height: 16px;border-radius: 3px;border: 1px solid transparent;}
.tag-order{background: #fff7e6;border-color: #ffd591;color: #d46b08;}
.tag-combo{background: #fff1f0;border-color: #ffa39e;color: #cf1322;}
.tag-normal{background: #f6ffed;border-color: #b7eb8f;color: #389e0d;}
.tag-empty{background: #fafafa;border-color: #d9d9d9;color: #999;}
.tag-changed{background: #fff2e8;border-color: #ffbb96;color: #d4380d;}

/* 组合编辑区 */
.combo_edit_wrap{display: flex;flex-direction: column;gap: 8px;width: 100%;padding: 4px 0;}
.combo_edit_line{
  display: flex;align-items: center;gap: 8px;width: 100%;
  box-sizing: border-box;padding: 8px 10px;
  background: #fafafa;border: 1px solid #f0f0f0;border-radius: 6px;
}
.combo_edit_line:hover{border-color: #ffccc7;background: #fffafa;}
.line_idx{
  flex-shrink: 0;width: 20px;height: 20px;border-radius: 50%;
  background: #fff1f0;color: #cf1322;font-size: 12px;font-weight: 600;
  display: inline-flex;align-items: center;justify-content: center;
}
.combo_edit_line .sel_sku_select{flex: 1;min-width: 160px;}
.qty_box{display: flex;align-items: center;gap: 4px;flex-shrink: 0;}
.qty_label{font-size: 14px;color: #999;font-weight: 600;}
.qty_input{width: 96px;}
.icon_del_btn{
  flex-shrink: 0;width: 28px;height: 28px;border: none;border-radius: 4px;
  background: transparent;color: #bfbfbf;cursor: pointer;padding: 0;
  display: inline-flex;align-items: center;justify-content: center;
}
.icon_del_btn:hover{background: #fff1f0;color: #f0423f;}
.add_line_btn{
  align-self: flex-start;height: 32px;padding: 0 12px;border-radius: 4px;
  border: 1px dashed #ffccc7;background: #fff;color: #f0423f;
  font-size: 12px;cursor: pointer;display: inline-flex;align-items: center;gap: 4px;
}
.add_line_btn:hover{background: #fff1f0;border-style: solid;}
.combo_hint{margin: 0;font-size: 12px;color: #999;line-height: 1.4;}
.history_btn{color: #666 !important;}
.history_btn:hover{color: var(--red, #f0423f) !important;}

.connect_main{position: relative;width: 100%;height: auto;box-sizing: border-box;padding: 0 24px 8px;background: #fff;line-height: 1;}
.search_product{display: flex;justify-content: space-between;align-items: flex-start;margin-bottom: 8px;}
.goods_info{display: flex;position: relative;width: 70%;}
.goods_info .img_box{width: 48px;height: 48px;background: #eee;border-radius: 6px;overflow: hidden;}
.goods_info .con_box{flex: 1;width: 0;margin-left: 10px;font-size: 12px;}
.goods_info .con_box .name{line-height: 16px;}
.goods_info .con_box .id{color: #999999;margin-top: 8px;}
.add_line{display: flex;justify-content: space-between;align-items: center;margin: 12px 0 16px;}

.btn_wrap{
  margin-top: 16px;padding-top: 14px;
  display: flex;flex-wrap: wrap;align-items: center;justify-content: flex-end;gap: 12px;
}
.url_bar{display: flex;align-items: center;gap: 8px;flex: 1;min-width: 320px;}
.url_label{flex-shrink: 0;font-size: 13px;color: #666;white-space: nowrap;}
.url_input{flex: 1;min-width: 200px;}
.action_bar{display: flex;align-items: center;gap: 8px;flex-shrink: 0;}
.tongkuan_mask{width: 100%;height: 100%;position: fixed;top: 0;left: 0;background: rgba(0, 0, 0, .5);z-index: 999;transition: all .5s;visibility: hidden;opacity: 0;}
.tongkuan_mask.active{visibility: visible;opacity: 1;}
.tongkuan_mask .tongkuan_main{width: 1200px;height: 800px;box-sizing: border-box;padding: 20px 30px;background: #fff;position: absolute;top: 50%;left: 50%;transform: translate(-50%,-70%);visibility: hidden;opacity: 0;transition: all .5s;display: flex;flex-direction: column;}
.tongkuan_mask.active .tongkuan_main{transform: translate(-50%,-50%);visibility: visible;opacity: 1;}
.tongkuan_main .icon-guanbi{font-size: 12px;color: #999;position: absolute;top: 16px;right: 16px;cursor: pointer;z-index: 222;}
.tongkuan_main .title{font-size: 20px;line-height: 1;}
.tongkuan_main .title2{margin-top: 10px;font-size: 24px;text-align: center;line-height: 1;}
.tongkuan_main .search_wrap{margin: 10px 50px;}
.tongkuan_main .content_wrap{display: flex;flex-direction: column;flex: 1;overflow-y: auto;}
.tongkuan_main .tk_content{flex: 1;height: 0;overflow: hidden auto;display: flex;flex-wrap: wrap;align-items: flex-start;padding-bottom: 10px;padding-left: 4px;}
.tk_content .product{width: 210px;height: auto;margin: 18px 18px 0 0;border-radius: 6px;box-shadow: 0 0 5px 0 #eee;overflow: hidden;}
.tk_content .product:nth-child(5n){margin-right: 0;}
.tk_content .product .img_box{width: 100%;height: 210px;overflow: hidden;}
.tk_content .product .title{margin: 10px 10px 0;font-size: 14px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;cursor: pointer;}
.tk_content .product .title:hover{color: var(--red);text-decoration: underline;}
.tk_content .product .price_line{padding: 10px;display: flex;justify-content: space-between;align-items: center;}
.tk_content .product .price_line .price{font-size: 14px;color: var(--red);}
.turn_page{display: flex;justify-content: flex-end;margin-top: 20px;}
.goods_info .search_btn:hover ,.goods_info .search_btn:focus{border-color: var(--red);color: var(--red);}
.table_wrap{margin-top: 30px;font-size: 12px;}
.get_config{color: var(--red);cursor: pointer;}
.get_config:hover{text-decoration: underline;}
.table_wrap .pingtai{width: 80px;margin: 0 auto;text-align: left;box-sizing: border-box;padding-left: 20px;}
.add_line .add_btn{width: 102px;height: 35px;box-sizing: border-box;border: 1px solid var(--red);border-radius: 4px;cursor: pointer;display: flex;justify-content: center;align-items: center;font-size: 14px;color: var(--red);}
.add_line .clear{font-size: 14px;color: #999999;display: flex;align-items: center;cursor: pointer;}
.add_line .clear .iconfont{font-size: 14px;margin-right: 8px}
.config_wrap .title_wrap{width: 100%;height: 50px;background: #f5f5f5;box-sizing: border-box;border: 1px solid #eee;display: flex;align-items: center;font-size: 14px;color: #999}
.config_wrap .title_wrap .t1{width: 320px;margin: 0 16px;}
.config_wrap .title_wrap .t2{width: 80px;text-align: center;}
.config_wrap .title_wrap .t3{width: 120px;margin: 0 30px 0 20px;text-align: center;}
.config_wrap .title_wrap .t4{flex: 1;width: 0;}
.config_wrap .content_wrap{margin-top: 20px;padding-bottom: 40px;border-bottom: 1px solid #eee;height: 220px;overflow-y: auto;overflow-x: hidden;font-size: 14px;}
.content_wrap .content_line{display: flex;align-items: flex-start;margin-top: 26px;}
.content_wrap .content_line:first-child{margin-top: 0;}
.content_line .b1{width: 320px;margin: 0 16px;line-height: 20px;box-sizing: border-box;padding-right: 50px;}
.content_line .b2{width: 80px;text-align: center;}
.content_line .b3{width: 120px;margin: 0 30px 0 20px;display: flex;justify-content: center;align-items: center;}
.content_line .b4{flex: 1;width: 0;display: flex;}
.content_line .b3 .t{margin-right: 10px;}
/* 底部操作区以 scoped .btn_wrap 为准；保留兼容旧 .btn 样式 */
.btn_wrap .btn{min-width: 120px;padding:0 10px;height: 32px;border-radius: 4px;display: flex;justify-content: center;align-items: center;margin-left: 20px;cursor: pointer;font-size: 12px;box-sizing: border-box;}
.btn_wrap .btn:nth-child(2){background: var(--red);color: #fff;}
.btn_wrap .btn:nth-child(3){border: 1px solid #ddd;color: #fff;background-color: #409eff;}
.btn_wrap .btn:nth-child(3):hover{background-color: #d5efff;color: #409eff;border: 1px solid #409eff;}
.tongkuan_main .el-button--primary ,.tongkuan_main .el-button--primary:hover{background-color: var(--red) !important;border-color: var(--red) !important;}

.sku_change_log_mask{width: 100%;height: 100%;position: fixed;top: 0;left: 0;background: rgba(0, 0, 0, .5);z-index: 999;transition: all .5s;visibility: hidden;opacity: 0;}
.sku_change_log_mask.active{visibility: visible;opacity: 1;}
.sku_change_log_mask .sku_change_log_main{width: 1200px;height: 650px;box-sizing: border-box;padding: 20px 30px;background: #fff;position: absolute;top: 50%;left: 50%;transform: translate(-50%,-70%);visibility: hidden;opacity: 0;transition: all .5s;display: flex;flex-direction: column;}
.sku_change_log_mask.active .sku_change_log_main{transform: translate(-50%,-50%);visibility: visible;opacity: 1;}
.sku_change_log_mask .icon-guanbi{font-size: 12px;color: #999;position: absolute;top: 16px;right: 16px;cursor: pointer;z-index: 222;}
.sku_change_log_mask .title{font-size: 20px;line-height: 1;}
.el-checkbox.is-bordered.el-checkbox--small {padding: 3px 5px 2px 6px !important;}
.el-dialog__body{padding: 0 10px 20px !important;}
.el-checkbox.is-bordered.el-checkbox--small{height: 26px !important;}
</style>
<style>

.page_links{line-height: 1;font-size: 14px;color: #999999;display: flex;margin-top: 25px;}
.page_links .el-breadcrumb__inner{font-weight: bold !important;color: #333 !important;}
.page_links .el-breadcrumb__inner.is-link{font-weight: initial !important;color: #999 !important;}
.page_links .el-breadcrumb__inner.is-link:hover{color: #f0423f !important;text-decoration: underline;}

.tongkuan_main .search_wrap .el-input__inner{border-radius: 6px;font-size: 16px;}
.tongkuan_main .search_wrap .el-input__suffix{right: 1px;display: flex;top: 1px;border-radius: 0 6px 6px 0;height: 38px;overflow: hidden;border-left: 1px solid #ddd;}
.tongkuan_main .search_wrap .el-input__suffix .el-input__suffix-inner{width: 80px;height: 38px;}
.tongkuan_main .search_wrap .el-input__suffix .el-input__suffix-inner .icons{width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;background: #f5f5f5;cursor: pointer;}
.tongkuan_main .search_wrap .el-input__suffix .el-input__suffix-inner .icons .iconfont{font-size: 16px;color: #999;}
.table_wrap .el-table::before{display: none;}
.table_wrap .el-table .el-table_1_column_2 .cell .num{color: #999;}
.table_wrap .el-table th.el-table__cell{background: #fff6f7;border-bottom: none !important;color: #666666;padding: 12px 0;}
.table_wrap .el-table .el-table__cell{padding: 24px 0;}
.table_wrap .el-table .cell{padding: 0 20px;text-align: center;font-size: 12px;color: #333;}
.table_wrap .el-table .el-table_1_column_1 .cell{text-align: center;}
.table_wrap .el-table .el-table_1_column_2 .cell{padding: 0 10px;}
.table_wrap .el-table th.el-table_1_column_2 .cell{text-align: left;}
.table_wrap .el-table td.el-table__cell, .table_wrap .el-table th.el-table__cell.is-leaf{border-bottom: none;}

.config_table .el-table__header-wrapper{border: 1px solid #eee !important;box-sizing: border-box;}
.config_table .el-table th.el-table__cell{background: #f5f5f5;border: none !important;color: #999;padding: 13.5px 0;}
.config_table .el-table td.el-table__cell{border-bottom: 1px solid #f5f5f5 !important;padding: 12px 0 !important;vertical-align: top;}
.config_table .el-table .cell{padding: 0 12px !important;}
.config_table .el-table .is-current-order-row td.el-table__cell{background: #fffaf5 !important;}
/* 覆盖旧规则 div{width:100%}，避免打乱组合行 flex */
.config_table .el-table td.el-table__cell .dd_sku_cell,
.config_table .el-table td.el-table__cell .dd_sku_meta,
.config_table .el-table td.el-table__cell .dd_sku_tags,
.config_table .el-table td.el-table__cell .qty_box,
.config_table .el-table td.el-table__cell .pdd_sku_info{width: auto; max-width: 100%;}
.config_table .el-table td.el-table__cell .combo_edit_wrap,
.config_table .el-table td.el-table__cell .combo_edit_line{width: 100%;}
.config_table .el-table td.el-table__cell .sel_sku_pic_box{width: 36px !important;}
.config_table .el-table td.el-table__cell .line_idx{width: 20px !important;}
.config_table .el-table td.el-table__cell .icon_del_btn{width: 28px !important;}
.config_table .el-table td.el-table__cell .qty_input{width: 96px !important;}
.config_table .el-table td.el-table__cell .add_line_btn{width: auto !important;}
.config_table .el-table td.el-table__cell .multi_sku_select{width: 100% !important;}
.config_table .el-table td.el-table__cell .line_spec_text{width: auto !important; flex: 1;}
.config_table .el-table td.el-table__cell .sel_sku_select{width: auto !important; flex: 1; min-width: 0;}
.config_table .el-table td.el-table__cell .url_bar,
.config_table .el-table td.el-table__cell .action_bar{width: auto;}
.config_table .el-table__body-wrapper::-webkit-scrollbar{width:4px;}
.config_table .el-table__body-wrapper::-webkit-scrollbar-thumb{background: #DDDDDD;border-radius: 4px;}
.config_table .el-table__body-wrapper::-webkit-scrollbar-track{background: #F2F2F2;border-radius: 4px;}

.image-uploader{position: absolute;left: 0;top: 0;width: 100%;height: 100%;opacity: 0;}
.search_filter_wrap{margin: 10px 50px;display: flex;gap: 20px;align-items: flex-start;border: 1px solid #eee;border-radius: 6px;padding: 16px;background: #fafafa;}
.search_filter_wrap .filter_left{flex: 1;min-width: 0;}
.search_filter_wrap .filter_title{font-size: 14px;font-weight: bold;color: #333;margin-bottom: 12px;}
.search_filter_wrap .filter_actions{display: flex;justify-content: flex-start;gap: 10px;margin-top: 12px;padding-top: 12px;border-top: 1px solid #eee;}
.search_filter_wrap .filter_group{display: flex;align-items: flex-start;gap: 0;margin-bottom: 0px;}
.el-checkbox.is-bordered+.el-checkbox.is-bordered{margin-left: unset !important;}
.search_filter_wrap .filter_group:last-child{margin-bottom: 0;}
.search_filter_wrap .group_name{flex-shrink: 0;width: 72px;font-size: 13px;color: #666;line-height: 32px;margin-bottom: 0;}
.search_filter_wrap .group_options{flex: 1;min-width: 0;display: flex;flex-wrap: wrap;gap: 2px;}
.search_filter_wrap .filter_left .el-checkbox{margin-right: 0;margin-bottom: 0;}
.search_filter_wrap .filter_left .el-checkbox__label{font-size: 12px;}
.search_filter_wrap .filter_right{flex-shrink: 0;width: 160px;display: flex;align-items: center;justify-content: center;}
.search-image{width: 140px;height: 140px;object-fit: contain;display: block;}
.search-image-placeholder{width: 140px;height: 140px;display: flex;align-items: center;justify-content: center;font-size: 12px;color: #999;background: #fff;border: 1px dashed #ddd;border-radius: 4px;text-align: center;padding: 10px;box-sizing: border-box;}
.search_wrap .search_box{height: 50px;box-sizing: border-box;background-color: #ffffff;border-radius: 4px 0vw 0vw 4px;border: solid 2px #fa5757;display: flex;align-items: center;position: relative;}
.search_wrap .search_box .type{width: 84px;color: #333333;cursor: pointer;text-align: center;line-height: 26px;border-right: 1px solid #ddd;}
.search_wrap .search_box .in{flex: 1;width: 0;margin: 0 15px;color: #333333;font-size: 16px;}
.search_wrap .search_box .el-icon-search{margin-left: 14px;font-size: 20px;color: #999;cursor: pointer;}
.search_wrap .search_box .icon-xiangji{margin-right: 14px;font-size: 24px;color: #999;cursor: pointer;position: relative;}
.search_wrap .search_btn{width: 132px;height: 50px;background-image: linear-gradient(180deg, #fa5757 0%, #fb6d6d 100%), linear-gradient(#ffffff, #ffffff);background-blend-mode: normal, normal;border-radius: 0vw 4px 4px 0vw;display: flex;justify-content: center;align-items: center;color: #ffffff;font-weight: bold;cursor: pointer;}


.content_line .b4 .el-select{width: 220px;margin-right: 10px;}
.el-input-number__decrease:hover, .el-input-number__increase:hover ,.el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path ,.el-select-dropdown__item.selected{color: var(--red);}
.input_number .el-input__inner:hover ,.el-input-number__decrease:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled), .el-input-number__increase:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled) ,.el-input__inner:focus ,.el-cascader .el-input .el-input__inner:focus, .el-cascader .el-input.is-focus .el-input__inner ,.el-select .el-input.is-focus .el-input__inner ,.el-select .el-input__inner:focus{border-color: var(--red);}

.screen_wrap{width: 100%;height: 47px;border-bottom: 1px solid #eeeeee;display: flex;align-items: center;justify-content: space-between}
.screen_wrap .title{
  font-weight: bold;
 /* margin-right: 60px;*/
}
.screen_wrap .title span{color: #fa5757;}
.order_sort{
  display: flex;
  align-items: center;
  div{
    margin-right: 20px;
    cursor: pointer;
    font-size: 14px;
    color: #999999;
  }
  .active{
    color: #fa5757;
  }
}
.active{
  color: #fa5757;
}

/* ══════ 搜同款弹窗（参照 SKU 替换弹窗排列美化） ══════ */
.tk-dialog{border-radius: 10px;overflow: hidden;background: #fff;}
.tk-dialog .el-dialog__header{
  background: #F5EEE3;padding: 15px 20px;margin: 0;
  display: flex;align-items: center;
}
.tk-dialog .el-dialog__title{display: none;}
.tk-dialog .el-dialog__headerbtn{top: 15px;right: 18px;}
.tk-dialog .el-dialog__headerbtn .el-dialog__close{font-size: 17px;color: #8C8579;font-weight: bold;}
.tk-dialog .el-dialog__headerbtn:hover .el-dialog__close{color: #C8443C;}
.tk-dialog .el-dialog__body{padding: 16px 20px;height: calc(88vh - 108px);min-height: 420px;overflow: hidden;color: #303133;}
.tk-dialog .el-dialog__footer{padding: 12px 20px;border-top: 1px solid #EFECE6;background: #FBFAF8;}
.tk-header{display: inline-flex;align-items: center;gap: 9px;}
.tk-header__bar{width: 4px;height: 18px;border-radius: 2px;background: #C8443C;}
.tk-header__text{font-size: 17px;font-weight: bold;color: #2F2B26;letter-spacing: 1px;}

/* 主体：左过滤 + 右结果 */
.tk-body{display: flex;gap: 16px;height: 100%;box-sizing: border-box;}
.tk-side{width: 360px;flex-shrink: 0;display: flex;flex-direction: column;gap: 12px;overflow-y: auto;padding-right: 4px;}
.tk-main{flex: 1;min-width: 0;display: flex;flex-direction: column;overflow: hidden;}

/* 左侧面板 */
.tk-panel{border: 1px solid #E9E4DA;border-radius: 10px;background: #fff;padding: 14px;box-sizing: border-box;}
.tk-panel--preview{flex-shrink: 0;min-height: 190px;display: flex;align-items: center;justify-content: center;padding: 10px;}
.tk-panel__title{margin: 0 0 10px;font-size: 14px;font-weight: bold;color: #2F2B26;}
.tk-filter{margin-bottom: 10px;}
.tk-filter:last-of-type{margin-bottom: 0;}
.tk-filter__name{margin: 0 0 5px;font-size: 12px;font-weight: bold;color: #6B655C;}
.tk-filter__opts{display: flex;flex-wrap: wrap;gap: 4px 10px;}
.tk-filter__opts .el-checkbox{margin-right: 0;height: auto;white-space: nowrap;}
.tk-filter__opts .el-checkbox__label{font-size: 12px;color: #606266;padding-left: 7px;}
.tk-filter__opts .el-checkbox__inner{width: 14px;height: 14px;}
.tk-filter__opts .el-checkbox__inner::after{height: 7px;left: 4px;top: 1px;border-width: 1.5px;}
.tk-filter__actions{display: flex;gap: 10px;margin-top: 12px;padding-top: 12px;border-top: 1px solid #F0ECE3;}
.tk-filter__actions .el-button{flex: 1;padding-left: 0;padding-right: 0;}
.tk-preview__img{max-width: 100%;max-height: 220px;object-fit: contain;border-radius: 6px;}
.tk-preview__empty{
  width: 100%;height: 180px;display: flex;align-items: center;justify-content: center;
  font-size: 12px;color: #B0AAA0;background: #FAF8F4;border: 1px dashed #DDD6C8;border-radius: 8px;text-align: center;
}

/* 右侧搜索条 */
.tk-search{
  height: 42px;flex-shrink: 0;box-sizing: border-box;
  border: 1.5px solid #C8443C;border-radius: 8px;background: #fff;
  display: flex;align-items: center;
}
.tk-search__ico{margin: 0 12px;font-size: 17px;color: #C8443C;}
.tk-search__in{flex: 1;width: 0;height: 100%;border: none;outline: none;font-size: 13px;color: #303133;background: transparent;}
.tk-search__in::placeholder{color: #B0AAA0;}
.tk-search__cam{margin: 0 12px;font-size: 21px;color: #9A9388;cursor: pointer;position: relative;line-height: 1;}

/* 结果统计条 */
.tk-resultbar{flex-shrink: 0;height: 46px;display: flex;align-items: center;border-bottom: 1px solid #EFECE6;}
.tk-resultbar__title{font-size: 14px;font-weight: bold;color: #2F2B26;}
.tk-resultbar__title em{font-style: normal;color: #C8443C;font-size: 16px;margin: 0 3px;}

/* 商品卡片网格：3 列 */
.tk-gridwrap{flex: 1;overflow-y: auto;padding: 14px 4px 8px 0;}
.tk-grid{display: grid;grid-template-columns: repeat(3, 1fr);gap: 14px;}
.tk-card{
  border: 1px solid #EDEAE4;border-radius: 8px;background: #fff;overflow: hidden;
  display: flex;flex-direction: column;transition: box-shadow .2s, border-color .2s;
}
.tk-card:hover{border-color: #F0C9C6;box-shadow: 0 4px 14px rgba(200,68,60,.10);}
.tk-card__img{width: 100%;aspect-ratio: 1 / 1;background: #F7F5F1;overflow: hidden;cursor: pointer;}
.tk-card__img img{width: 100%;height: 100%;object-fit: cover;transition: transform .25s;}
.tk-card:hover .tk-card__img img{transform: scale(1.04);}
.tk-card__name{
  margin: 9px 12px 0;font-size: 13px;line-height: 1.4;color: #303133;cursor: pointer;
  display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;min-height: 36px;
}
.tk-card__name:hover{color: #C8443C;}
.tk-card__no{margin: 3px 12px 0;font-size: 11px;color: #B0AAA0;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;}
.tk-card__price{margin: 6px 12px 0;font-size: 16px;font-weight: bold;color: #C8443C;}
.tk-card__actions{display: flex;gap: 8px;padding: 10px 12px 12px;margin-top: auto;}
.tk-card__btn{
  flex: 1;height: 30px;border-radius: 4px;font-size: 12px;cursor: pointer;
  display: inline-flex;align-items: center;justify-content: center;transition: all .15s;
}
.tk-card__btn--plain{background: #fff;border: 1px solid #DCDFE6;color: #606266;}
.tk-card__btn--plain:hover{border-color: #C8443C;color: #C8443C;}
.tk-card__btn--red{background: #FDF0EF;border: 1px solid #F3C4C0;color: #C8443C;}
.tk-card__btn--red:hover{background: #FAE2E0;border-color: #E8B4B0;color: #B83A33;}

/* 空数据 */
.tk-main .el-empty{flex: 1;display: flex;flex-direction: column;align-items: center;justify-content: center;}

/* 弹窗主按钮红色（选择器提权以覆盖组件旧 scoped 规则） */
.tk-dialog .tk-filter__actions .el-button--primary,
.tk-dialog .tk-filter__actions .el-button--primary:hover,
.tk-dialog .tk-filter__actions .el-button--primary:focus{
  background-color: #C8443C !important;border-color: #C8443C !important;
}

/* 底部栏 */
.tk-footer{display: flex;align-items: center;justify-content: space-between;}
.tk-footer__hint{font-size: 12px;color: #B0AAA0;}

/* 窄屏自适应：2 列 / 1 列 */
@media (max-width: 1400px){.tk-grid{grid-template-columns: repeat(2, 1fr);}}
@media (max-width: 1100px){.tk-side{width: 240px;}.tk-grid{grid-template-columns: repeat(2, 1fr);}}
</style>
